import React from "react";

import { Alert } from "react-bootstrap";
import styled from "styled-components";

const StyledAlertHeading = styled(Alert.Heading)`
  margin: 0;
`;

function ExpiredVacancyAlert() {
  return (
    <div className="container-xxl">
      <Alert className="text-center" variant="warning">
        <StyledAlertHeading>This job has expired.</StyledAlertHeading>
      </Alert>
    </div>
  );
}

export default ExpiredVacancyAlert;
